import React from 'react'

// Tag mã (course_idcode/course_class_idcode/student_idcode...) đặt TRƯỚC tên trong danh sách chọn -
// tái dùng ĐÚNG style đã có sẵn ở renderCourse() (Workspace/Course/containers/Courses.js, tag mã khóa
// trên course card) thay vì tự chế style mới, cho nhất quán toàn app.
export const IdcodeTag = ({children}) => {
  if (!children) return null
  return (
    <span className="px-1.5 py-0.5 rounded-md background-100 font-mono text-2xs font-bold text-color-400 tracking-wider whitespace-no-wrap flex-shrink-0">
      {children}
    </span>
  )
}
